import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "checkout-footer" }
const _hoisted_2 = {
  class: "gfu-bt _mt-3",
  "data-qa": "checkout-footer:GamefoundInfo"
}
const _hoisted_3 = {
  class: "gfu-bt",
  "data-qa": "checkout-footer:AdyenInfo"
}
const _hoisted_4 = { class: "gfu-bt" }
const _hoisted_5 = {
  class: "gfu-bt",
  "data-qa": "checkout-footer:StoreInfo"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_external_link = _resolveComponent("external-link")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.showAdyenPaymentInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutFooterCompanyInformationParagraph), 1 /* TEXT */),
          _createVNode(_component_base_title, {
            as: "h3",
            level: "h4",
            class: "_mt-3 _mb-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutFooterProcessingPaymentsSectionTitle), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.Checkout.CheckoutFooterProcessingPaymentsSectionParagraph
            }, {
              default: _withCtx(() => [
                ($options.isAdyenPaymentProvider)
                  ? (_openBlock(), _createBlock(_component_external_link, {
                      key: 0,
                      "format-key": "0",
                      href: "https://www.adyen.com/",
                      class: "gfu-link gfu-link--accent"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("Adyen", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_external_link, {
                      key: 1,
                      "format-key": "0",
                      href: "https://stripe.com/",
                      class: "gfu-link gfu-link--accent"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("Stripe", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($options.isDccEnabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_base_title, {
            as: "h3",
            level: "h4",
            class: "_mt-3 _mb-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutFooterDccSectionTitle), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString($options.dccSectionParagraph) + " ", 1 /* TEXT */),
            _createVNode(_component_external_link, {
              class: "gfu-link gfu-link--accent",
              target: "_blank",
              href: $options.articleUrl,
              rel: "noopener noreferrer nofollow"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutFooterDccSectionReadMoreLink), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["href"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h4",
      class: "_mt-3 _mb-2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutFooterPlatformLegalSectionTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_5, _toDisplayString($options.effectiveDisclaimer), 1 /* TEXT */)
  ]))
}